import * as React from 'react'
import { CompanyNameBadge } from '@/modules/drivers/shared/viewBars/CompanyNameBadge'

interface HeadBarProps {
  title: string
  icon: React.ReactElement
  description?: string
  children?: React.ReactNode
  actions?: React.ReactNode
}

export const HeadBar = ({
  title,
  icon,
  children,
  description,
  actions,
}: HeadBarProps) => (
  <div className="tw-flex tw-flex-col tw-items-left tw-rounded-t-xl tw-border-b tw-p-4">
    <div className="tw-flex tw-items-center tw-gap-3 tw-rounded-t-xl">
      <CompanyNameBadge />
      <div>{icon}</div>
      <div className="tw-flex-1 tw-text-xl tw-font-semibold">{title}</div>
      {actions && <div className="tw-shrink-0">{actions}</div>}
    </div>
    {description && <p className='tw-text-sm tw-font-regular'>{description}</p>}
    {children && <div className="tw-ml-4">{children}</div>}
  </div>
)
